import React from 'react';
import { makeStyles } from '../styles';
import LoadingSpinner from '../LoadingSpinner';
const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
    },
}));
function SuspenseFallback() {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement("span", null,
            React.createElement(LoadingSpinner, { size: "large" }))));
}
export default SuspenseFallback;
//# sourceMappingURL=SuspenseFallback.js.map